import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import { QC_NAV, QC_PATHS } from './qoreConnectConfig';
import { QC_ICONS } from './QoreConnectIcons';
import './QoreConnect.css';

const NAV_ICONS = {
  forum: QC_ICONS.forum,
  mentorship: QC_ICONS.mentorship,
  jobs: QC_ICONS.jobs,
};

const resolveTab = (pathname) => {
  if (pathname === QC_PATHS.hub || pathname === '/community') return 'hub';
  const match = QC_NAV.find((n) => n.id !== 'hub' && pathname.startsWith(n.path));
  return match?.id || 'hub';
};

const QoreConnectShell = ({
  children,
  activeTab,
  hero,
  mainClass = '',
  hideNav = false,
  fullBleed = false,
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const current = activeTab || resolveTab(location.pathname);

  return (
    <div className="qc-page">
      <Header />

      {hero && (
        <header className="qc-hero">
          {hero.badge && <div className="qc-hero__badge">{hero.badge}</div>}
          {hero.title && (
            <h1 className="qc-hero__title">
              {hero.titleParts ? (
                hero.titleParts.map((part, i) => (
                  <span key={part.key || i} className={part.className || ''}>
                    {part.text}{' '}
                  </span>
                ))
              ) : (
                hero.title
              )}
            </h1>
          )}
          {hero.subtitle && <p className="qc-hero__subtitle">{hero.subtitle}</p>}
          {hero.stats && <div className="qc-hero__stats">{hero.stats}</div>}
          {hero.actions && <div className="qc-cta__actions" style={{ marginTop: '1rem' }}>{hero.actions}</div>}
          {hero.extra}
        </header>
      )}

      {!hideNav && (
        <nav className="qc-nav" aria-label={t('qoreConnect.pageTitle')}>
          <div className="qc-nav__inner">
            <Link to={QC_PATHS.hub} className="qc-nav__brand">
              <span className="qc-nav__pulse" aria-hidden />
              {t('qoreConnect.pageTitle')}
            </Link>
            {QC_NAV.filter((n) => n.id !== 'hub').map((item) => {
              const Icon = NAV_ICONS[item.id];
              return (
                <Link
                  key={item.id}
                  to={item.path}
                  className={['qc-nav__link', current === item.id ? 'qc-nav__link--active' : ''].filter(Boolean).join(' ')}
                >
                  {Icon && (
                    <span className="qc-nav__link-icon" aria-hidden>
                      <Icon />
                    </span>
                  )}
                  {t(item.labelKey)}
                </Link>
              );
            })}
          </div>
        </nav>
      )}

      {fullBleed ? children : (
        <main className={`qc-main ${mainClass}`.trim()}>{children}</main>
      )}

      <Footer />
    </div>
  );
};

export default QoreConnectShell;